<template>
  <div class="history-results">
    <h2>ຜົນການອອກເລກລາງວັນ</h2>
    <table class="table table-bordered">
      <thead>
        <tr>
          <td>ງວດວັນທີ່</td>
          <td width="13%">ເລກ 5 ໂຕ</td>
          <td width="13%">ເລກ 4 ໂຕ</td>
          <td width="13%">ເລກ 3 ໂຕ</td>
          <td width="13%">ເລກ 2 ໂຕ</td>
          <td width="13%">ເລກ 1 ໂຕ</td>
          <td width="13%">ເລກ 2 ພິເສດ</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>
            <span class="full-date">{{ item.lotto_date | date }}</span>
            <span class="short-date">{{ item.lotto_date | shortdate }}</span>
          </td>
          <td>{{ item.results | result('digit5') }}</td>
          <td>{{ item.results | result('digit4') }}</td>
          <td>{{ item.results | result('digit3') }}</td>
          <td>{{ item.results | result('digit2_top') }}</td>
          <td>{{ item.results | result('digit1') }}</td>
          <td>{{ item.results | result('digit2_special') }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import moment from "@/moment"

import LottoService from "@/services/lottoService"

export default {
  name: 'HistoryResults',
  data() {
    return {
      data: []
    }
  },
  computed: {
    items() {
      return this.data
    }
  },
  methods: {
    getResults() {
      LottoService.getHistories().then((response) => {
        if (response.status === 'success') {
          this.data = response.data
        }
      })
    }
  },
  created() {
    this.getResults()
  },
  filters: {
    date(param) {
      return moment(param).format("LL")
    },
    shortdate(param) {
      return moment(param).format("DD/MM/YY")
    },
    result(param, digit) {
      if (param) {
        let results = param
        return results[digit]
      } else {
        return '-'
      }
    }
  },
}

</script>
<style lang="scss">
.history-results {

  h2 {
    text-align: center;
    font-size: 1.5rem;
    background-color: #FFF;
    padding: 3px;
    line-height: 1;
    padding: 5px 0;
    color: #666;
    border: 3px solid #999;
    background-color: #EFEFEF;
  }
  .table {
    background-color: #FFF;

    thead{
      background-color: #EEE;
    }

    tr {
      td {
        padding: 5px;
        text-align: center;

        .short-date {
          display: none;
        }
      }
    }
  }
}

@media only screen and (max-width:500px) {
  .history-results .table tr td {
    .full-date {
      display: none;
    }
    .short-date {
      display: block;
    }
  }
}
</style>
